/*
 * Copyright (c) 2023 Shabélab inc.
 * All Rights Reserved.
 * 
 * This software is the property of Shabélab inc.
 * 
 * This software is supplied "AS IS" without any warranties and support.
 * 
 * Distribution, reproduction, and modification of this software or 
 * any derivative works are forbidden without written permission from 
 * Shabélab inc.
 */

import {
  SCROLL_BOTOOM,
  REALTIME_TOOLTIP_ID,
} from '../actions/Types'

function user (state = {}, action) {

  const { params } = action

  switch (action.type) {

    case SCROLL_BOTOOM:

      // console.log("is_scroll_bottom ", params)

      let is_scroll_bottom = true
      if (params && params.is_scroll_bottom === false) {
        is_scroll_bottom = false
      }

      return {
        ...state,
        is_scroll_bottom: is_scroll_bottom,
      }


    case REALTIME_TOOLTIP_ID:

    // console.log("is_scroll_bottom ", params)

    let tooltip_id = ""
    if (params && params.tooltip_id) {
      tooltip_id = params.tooltip_id
    }

    return {
      ...state,
      tooltip_id: tooltip_id,
    }


    // case TOGGLE_FILLER_HIDE :

    //   console.log("TOGGLE_FILLER_HIDE: ", params)

    //   return {
    //     ...state,
    //     show_filler: params.show_filler,
    //   }

    // case SET_STREAM :
    //   return {
    //     ...state,
    //     streams: params.streams,
    //   }

    // case SET_AD_CODE :
    //   return {
    //     ...state,
    //     ad_code: params.ad_code,
    //   }

    // case SET_GUEST_MODE:

    //   // console.log("SET_GUEST_MODE", params.guest_mode)
    
    //   return {
    //     ...state,
    //     guest_mode: params.guest_mode,
    //   }

    default :
      return state
  }
}

export default user
